<template>
  <div class="create__post">
    <BlogCoverPreview v-show="this.$store.state.blogPhotoPreview" />
    <div class="container">
      <div class="err__msg" :class="{ invisible: !err }">
        <p><span>Error:</span>{{ this.errMsg }}</p>
      </div>
      <div class="blog__info">
        <input type="text" placeholder="اكتب اسم المنشور" v-model="blogTitle" />
        <div class="upload__file">
          <label for="blog-photo">
            ارفع صورة الغلاف
          </label>
          <input
            type="file"
            ref="blogPhoto"
            id="blog-photo"
            accept=" .png, .jpg, .jpeg"
            @change="fileChange"
          />
          <button
            @click="openPreview"
            class="preview"
            :class="{ button__inactive: !this.$store.state.blogPhotoFileURL }"
          >
            عرض صورة الغلاف
          </button>
          <span>
            الملف الذي تم اختياره : {{ this.$store.state.blogPhotoName }}
          </span>
        </div>
      </div>
      <div class="editor">
        <vue-editor
          :editorOptions="editorSettings"
          v-model="blogHTML"
          useCustomImageHandler
          @image-added="imageHandler"
        />
      </div>
      <div class="blog__actions">
        <button>انشر المدونه</button>
        <router-link class="router__button" :to="{name:'PostPreview'}"
          >عرض اولي للمنشور</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/storage'
import Quill from "quill";
import BlogCoverPreview from "../../components/BlogCoverPreview.vue";
window.Quill = Quill;
const imageResize = require("quill-image-resize-module").default;
Quill.register("modules/imageResize", imageResize);

export default {
  name: "CreatePost",
  components: {
    BlogCoverPreview,
  },
  data() {
    return {
      file: null,
      err: null,
      errMsg: null,
      editorSettings: {
        modules: {
          imageResize: {},
        },
      },
    };
  },
  computed: {
    profileId() {
      return this.$store.state.profileId;
    },
    blogCoverPhotoName() {
      return this.$store.state.blogPhotoName;
    },
    blogTitle: {
      get() {
        return this.$store.state.blogTitle;
      },
      set(payLoad) {
        this.$store.commit("updateBlogTitle", payLoad);
      },
    },
    blogHTML: {
      get() {
        return this.$store.state.blogHTML;
      },
      set(payLoad) {
        this.$store.commit("newBlogPost", payLoad);
      },
    },
  },
  methods: {
    fileChange() {
      this.file = this.$refs.blogPhoto.files[0];
      const fileName = this.file.name;
      this.$store.commit("fileNameChange", fileName);
      this.$store.commit("createFileUrl", URL.createObjectURL(this.file));
    },
    openPreview() {
      this.$store.commit("openPhotoPreview");
    },
    imageHandler(file, Editor, cursorLocation, resetUploader) {
      const storageRef = firebase.storage().ref();
      const docRef = storageRef.child(`documents.blogPostPhotos/${file.name}`);
      docRef.put(file).on(
        "state_changed",
        (snapshot) => {
          console.log(snapshot);
        },
        (err) => {
          console.log(err);
        },
        async () => {
          const downloadURL = await docRef.getDownloadURL();
          Editor.insertEmbed(cursorLocation, "image", downloadURL);
          resetUploader();
        }
      );
    },
  },
};
</script>

<style lang="scss">
.create__post {
  position: relative;
  height: 100%;
  button {
    margin-top: 0;
  }
  .router__button {
    text-decoration: none;
    color: #fff;
  }
  label,
  button,
  .router__button {
    transition: 0.5s ease-in-out all;
    align-self: center;
    font-size: 14px;
    cursor: pointer;
    border-radius: 20px;
    padding: 12px 24px;
    color: #fff;
    background-color: #303030;
    text-decoration: none;
    &:hover {
      background-color: rgba(48, 48, 48, 0.7);
    }
  }
  .container {
    position: relative;
    height: 100%;
    padding: 10px 25px 60px;
  }
  // error styling
  .invisible {
    opacity: 0 !important;
  }
  .err__msg {
    width: 100%;
    padding: 12px;
    border-radius: 8px;
    color: #fff;
    margin-bottom: 10px;
    background-color: #303030;
    opacity: 1;
    transition: 0.5s ease all;
    p {
      font-size: 14px;
    }
    span {
      font-weight: 600;
    }
  }
  .blog__info {
    display: flex;
    margin-bottom: 32px;
    @media (max-width: 750px) {
      flex-direction: column;
    }
    input:nth-child(1) {
      min-width: 300px;
    }
    input {
      transition: 0.5s ease-in-out all;
      padding: 10px 4px;
      border: none;
      border-bottom: 1px solid #303030;
      &:focus {
        outline: none;
        box-shadow: 0 1px 0 0 #303030;
      }
    }
    .upload__file {
      flex: 1;
      margin-left: 16px;
      position: relative;
      display: flex;
      @media (max-width: 750px) {
        flex-direction: column;
        margin: 40px 0 0 0;
      }
      input {
        display: none;
      }
      .preview {
        margin: 0 16px;
        text-transform: initial;
        @media (max-width: 750px) {
          margin: 15px;
        }
      }
      span {
        font-size: 12px;
        margin-left: 16px;
        align-self: center;
      }
    }
  }
  .editor {
    height: 70vh;
    display: flex;
    flex-direction: column;
    direction: ltr;
    .quillWrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    .ql-container {
      display: flex;
      flex-direction: column;
      height: 100%;
      overflow: scroll;
    }
    .ql-editor {
      padding: 20px 16px 30px;
    }
  }
  .blog__actions {
    margin-top: 32px;
    button {
      margin-left: 16px;
    }
  }
  .button__inactive {
    background-color: rgba(48, 48, 48, 0.7);
    cursor: not-allowed;
  }
}
</style>
